<div class="sticky-nav-bar">
  <gc-button
    [variant]="'plain'"
    [icon]="'arrowLeft'"
    (clicked)="navigateToInstallationReportingPage()"
    >{{ groupAgreementDetails()?.propertyAddress }}</gc-button
  >
</div>

<div class="content-wrapper">
  <div class="info-card-section">
    @for (card of infoCards(); track $index) {
      <div class="info-card">
        @for (row of card; track row.translationKey) {
          <div class="row">
            <gc-text [variant]="'largeParagraphBold'">{{
              row.translationKey | translate
            }}</gc-text>
            <gc-text [variant]="'paragraph'"
              >{{ row.value | booleanTranslate }}
            </gc-text>
          </div>
        }
      </div>
    }
  </div>

  <app-group-agreement-details-table
    [tableTitle]="'tabletoolBar.building'"
    [tableTitleCount]="allBuildingRows().length"
    [tableColumns]="buildingTableColumn"
    [tableRows]="tableRowsBuildings()"
    [currentItemsPerPage]="currentItemsPerPageBuildings()"
    [activePage]="activePageBuildings()"
    [numberOfPages]="numberOfPagesBuildings()"
    [searchFilter]="buildingSearchQuery()"
    (rowClicked)="onBuildingRowClicked($event)"
    (itemsPerPageSelected)="onBuildingsPageSizeChange($event)"
    (paginationChanged)="onBuildingsPageChange($event)"
    (searchInputChanged)="onBuildingSearchChanged($event)"
  />

  <app-group-agreement-details-table
    [tableTitle]="'tabletoolBar.deliveryPoint'"
    [tableTitleCount]="allDeliveryPointRows().length"
    [tableColumns]="pointTableColumn"
    [tableRows]="tableRowsDeliveryPoints()"
    [currentItemsPerPage]="currentItemsPerPageDeliveryPoints()"
    [activePage]="activePageDeliveryPoints()"
    [numberOfPages]="numberOfPagesDeliveryPoints()"
    [searchFilter]="deliveryPointSearchQuery()"
    (rowClicked)="onDeliveryPointRowClicked($event)"
    (itemsPerPageSelected)="onDeliveryPointsPageSizeChange($event)"
    (paginationChanged)="onDeliveryPointsPageChange($event)"
    (searchInputChanged)="onDeliveryPointSearchChanged($event)"
  />
</div>

@if (selectedReport(); as report) {
  <app-installation-reporting-mdu-modal
    [report]="report"
    [groupAgreementId]="groupAgreementId()!"
    [ifsNumber]="ifsNumber()!"
    (closed)="closeReportModal()"
    (saved)="onReportSaved()"
  />
}
